/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Section, Content, Copy, Title, Link, Grid, GridSet, GridItem, Icon, DateRangePickerDropDown, ListTable, Control } from '@insticator/insticator-ui'; // iui-material
//utils
import { isAfterFourPM, getDateNYC } from '@insticator/insticator-ui'; // iui-utils
import { transpileByStoryTableBody, transpileByStoryTableColumnHead } from 'utils/transpilers/datavisualization';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/analytics/detail/metrics/topstoryclicks/topstoryclicks_styles';



/* ========== ~~~~~~~~~~ DATA TOP STORY CLICKS ~~~~~~~~~~ ========== */
class TopStoryClicks extends Component {
    constructor(props){
        super(props);
        this.state = {
            indexClicked: null
        };
    }

    componentWillMount(){
        this.props.getTopStoryClicks(`&accountUUID=${this.props.accountUUID}&startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);
    }

    componentWillUnmount() {
        this.props.clearDetailState();
    }

    handleDateRangeApply = ()=>{
        this.props.getTopStoryClicks(`&accountUUID=${this.props.accountUUID}&startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);
    };

    linkToEmbed = (index, embedUUID) => {
        this.setState({indexClicked: index}); //this will be reset when homepage loads
        const accountUUID = this.props.isDataReceived ? false : this.props.accountUUID;
        this.props.viewAnalytics(embedUUID, accountUUID);
    };
    //this method returns props needed to export all data that is shown on detailTable to an excel sheet
    //it takes in fileName, and excludedColumns
    //since I am passing various props that arent data specific in to the table component I need to exclude things like disabled, handleRowClick, etc.
    exportProps = () => ({ fileName: 'Top Clicked Stories', excludedColumns: ['question_uuid', 'embed_uuid', 'processing', 'handleRowClick', 'disabled', ''] });

    render() {

        return(
            <Page name={`topstoryclicks`} klass={`${this.props.classes.topstoryclicks}`}>
                <Content>

                    <Section name={`tabledetailheader`}>
                        <Grid>
                            <GridSet direction={`horizontal`} name={`tabledetailtitle`}>
                                <GridItem>
                                    <Copy>
                                        <Link type={`internal`} behavior={`back`} text={`Back to all metrics`} color={`primary`} action={`dashboard/home`} icon={`hand-point-left`} />
                                        <Title><h2>{'Most Clicked Stories'}</h2></Title>
                                    </Copy>
                                </GridItem>
                                <GridItem>
                                    <DateRangePickerDropDown updateRange={this.props.updateDateRange} range={this.props.dateRange} disabledDays={[ { after: new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]} handleApply={this.handleDateRangeApply} use4PMLogic={true} />
                                </GridItem>
                            </GridSet>
                        </Grid>
                    </Section>

                    <Section name={`tabledetailtable`}>
                        <ListTable
                            name={`rank`}
                            type={`fixed-column`}
                            fixedColWidth={75}
                            size={`full`}
                            columnHeads={transpileByStoryTableColumnHead(true)}
                            data={transpileByStoryTableBody(this.props.topStoryClicks, this.linkToEmbed, this.state.indexClicked)}
                            exportData={this.exportProps()}
                            paginationLocation={`top`}
                            rowsPerPage={15}
                            clickableRow={true}
                            loading={this.props.topStoryClicksFetching}
                            moreDetails={false}
                        />
                    </Section>

                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(TopStoryClicks);
